import { ArrowUp } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ArrowUpIcon = createLucideIcon(ArrowUp);
